const meta = {
  id:          'daggerheart',
  name:        'Daggerheart',
  shortName:   'DH',
  description: 'Daggerheart by Darrington Press',
  iconId:      'system.daggerheart',
  order:       1,
};

export default meta;
